<template>
  <div class="container py-10 ">
    <transition name="fade" mode="out-in">
      <div v-if="submitted" class="text-center py-10">
        <h2>Successfully Submitted</h2>
        <p>Your renewal has been submitted and will be processed soon.</p>
        <d-btn href="https://awiqcp.org/" style="margin-top: 25px">
          Return Home
        </d-btn>
      </div>
      <div v-else class="flex flex-wrap -mx-5">
        <div class="w-full md:w-5/12 lg:w-4/12 px-5">
          <h1 class="font-bold text-primary-500 text-3xl">
            Renew Your Licensing
          </h1>
          <p class="mb-5">
            To complete the annual renewal of your licensing, please check the boxes under the "Non-refundable Fee and Code of Ethics Acknowledgement". <a href="https://awiqcp.org/woodworkers/qcp-fees/" target="_blank" rel="noopener noreferrer">Click here to view Annual Fee Amount.</a>
          </p>
          <p class="mb-5">
            Failure to complete the renewal process (including payment of fees) by Dec. 31st preceding the renewal year will result in late fees, suspension and revocation of the licensee company, as set forth in Section 3 of published QCP Policies. The Policies are available on this website free of charge under "Resources".
          </p>
        </div>
        <div class="w-full md:w-7/12 lg:w-8/12 px-5">
          <transition name="fade" mode="out-in">
            <page-one v-if="currentPage == 1" />
            <page-two v-if="currentPage == 2" />
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import dayjs from 'dayjs';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { RENEWAL_FORM } from '@resources/scripts/store/mutation-types';
  import PageOne from './components/Renewal/PageOne.vue';
  import PageTwo from './components/Renewal/PageTwo.vue';


  const { mapGetters, mapActions } = createNamespacedHelpers('renewalForm');

  export default {
    parent: true,
    components: {
      PageOne,
      PageTwo,
    },

    props: {
      lateFee: Number,
      testOrganization: Object,
      firstContact: Object,
      renewalDate: String,
      expirationDate: String,
    },

    computed: {
      ...mapFields({
        fields: ['startRenewalDate', 'endRenewalDate', 'organizationId'],
        module: 'renewalForm',
        base: 'formFields',
        mutation: RENEWAL_FORM.FORM_FIELDS,
      }),

      ...mapGetters([
        'currentPage',
        'submitted',
      ]),
    },

    mounted() {
      this.prepareStore();
    },

    methods: {
      ...mapActions([
        'setLateFeeAmount',
        'setRenewalFeeAmount',
      ]),

      prepareStore() {
        this.setLateFeeAmount(Number.parseFloat(this.lateFee));
        this.setRenewalFeeAmount(Number.parseFloat(this.testOrganization.fee_renewal_prorated_calc));
        this.startRenewalDate = dayjs(this.renewalDate);
        this.endRenewalDate = dayjs(this.expirationDate);
        this.organizationId = this.testOrganization.organization_id;
      },
    },
  };
</script>